import { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DashboardNavbar } from "./DashboardNavbar";
import { DashboardSidebar } from "./DashboardSidebar";
import { TimeMachine } from "./TimeMachine";
import { StackedContainer } from "@poseidon/ui/styles/layout";
import { Outlet } from "react-router-dom";
import ErrorBoundary from "@poseidon/ui/components/ErrorBoundary";
import { BreadcrumbContainer } from "../crumbs/BreadcrumbContainer";

const DashboardLayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  minHeight: "100vh",
  paddingTop: 64,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 280,
  },
}));

export const DashboardLayout = ({ app, navItems, enableTimeMachine }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  return (
    <>
      <Box>
        <DashboardLayoutRoot id="dlr" mt={4}>
          <Box
            sx={{
              display: "flex",
              flex: "1 1 auto",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <BreadcrumbContainer sx={{ mx: 2, my: 3 }} />
            <StackedContainer style={{ alignItems: "stretch", flex: 1 }}>
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </StackedContainer>
          </Box>
        </DashboardLayoutRoot>
        <DashboardNavbar app={app} onSidebarOpen={() => setSidebarOpen(true)} />
        <DashboardSidebar
          app={app}
          items={navItems}
          onClose={() => setSidebarOpen(false)}
          open={isSidebarOpen}
        />
      </Box>
      {enableTimeMachine && <TimeMachine />}
    </>
  );
};
